import { useEffect, useState } from "react"
import {
    selectAnomalyUoMUnits,
    selectAnomalyEquipmentTypes
} from "src/redux/slicers/buildingSummarySlice"
import { useDispatch, useSelector } from "react-redux"

const CustomChart = ({ isPreview, llmResponse, id, equipmentType }) => {

    const [chartData, setChartData] = useState([])

    const [error, setError] = useState(false)

    const { uomUnits } = useSelector(selectAnomalyUoMUnits)
    const { equipmentTypes } = useSelector(selectAnomalyEquipmentTypes)


    const formatChartData = (data) => {
        console.log(data)
    }


    const getChartData = () => {
        try {
            const formatData = []
            let dataArray = ""
            const startIndex = llmResponse.indexOf("[");
            let endIndex = startIndex;
            let i = startIndex
            if (startIndex !== -1) {
                let bracketCount = 0;
                // Iterate through the string only once
                for (i; i <= llmResponse.length; i++) {
                    if (llmResponse[i] === "[") {
                        bracketCount = bracketCount + 1;
                    } else if (llmResponse[i] === "]") {
                        bracketCount = bracketCount - 1;
                        if (bracketCount === 0) {
                            endIndex = i + 1;
                            break;
                        }
                    }
                }
                // Extract the array string
                dataArray = llmResponse.substring(startIndex, endIndex);
            }

            const actualData = JSON.parse(dataArray)


            if (actualData?.length > 0) {
                actualData.forEach((item) => {
                    const propertyDetails = equipmentTypes[equipmentType]?.find(
                        (x) => x?.targetKey === item?.metric || x?.tisDisplayName === item?.metric
                    ) || {}
                    const unitDetails = uomUnits?.find(x => x?.UoM === propertyDetails?.targetMeasureUnit && x?.subType === propertyDetails?.targetMeasureType)
                    const uom = unitDetails?.Symbol || ""
                    const newItem = {
                        propertyKey: propertyDetails?.propertyKey,
                        tisDisplayName: propertyDetails?.tisDisplayName,
                        uom: uom,
                        metric: item?.metric,
                        value: item?.value,
                        timestamp: item?.timestamp
                    }
                    formatData.push(newItem)
                })
                formatChartData(actualData)
            }
        } catch (error) {
            setError(true)
        }
    }

    useEffect(() => {
        if (llmResponse) {
            getChartData()
        }
    }, [llmResponse])



    return (
        <div>
            <h1>Custom Chart</h1>
        </div>
    )

}


export default CustomChart